import React from 'react';
import './About.css';

const highlights = [
  { icon: '🏫', title: 'Multi-Stakeholder Approach', desc: 'Working alongside schools, parents, and organisations to build a holistic support ecosystem around every student.' },
  { icon: '🎯', title: 'Individualized Learning Plans', desc: 'Every child is unique — our programmes are custom-designed to fit each student\'s specific pace, style, and challenges.' },
  { icon: '💡', title: 'Holistic Development', desc: 'Addressing both academic difficulties and emotional well-being to foster confident, self-sufficient learners.' },
];

const stats = [
  { icon: '📚', label: 'NIOS Coaching',     value: 'Reg & Exam'  },
  { icon: '⭐', label: 'Special Education', value: 'Inclusive'   },
  { icon: '🧠', label: 'LD Management',     value: 'Expert Care' },
  { icon: '💬', label: 'Counselling',        value: '1-on-1'     },
];

export default function About() {
  return (
    <section className="about reveal" id="about">
      <div className="about-inner">
        {/* Left: Text */}
        <div className="about-text">
          <span className="section-badge">About Us</span>
          <h2 className="section-title">More Than Just Tutoring</h2>
          <p className="about-desc">
            Akshara Learning Centre offers personalized educational support tailored to address
            individual learning challenges. We work closely with organisations, school management,
            and parents to create holistic development plans for every student.
          </p>
          <p className="about-desc">
            Whether you're struggling with academic subjects or seeking emotional guidance,
            Akshara is your trusted partner in educational success — offering NIOS Coaching,
            Special Education, and much more.
          </p>
          <div className="highlights">
            {highlights.map((h) => (
              <div className="highlight-card" key={h.title}>
                <div className="highlight-icon">{h.icon}</div>
                <div>
                  <strong>{h.title}</strong>
                  <p>{h.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Stats */}
        <div className="about-stats">
          {stats.map((s) => (
            <div className="about-stat-card" key={s.label}>
              <div className="about-stat-icon">{s.icon}</div>
              <div className="about-stat-value">{s.value}</div>
              <div className="about-stat-label">{s.label}</div>
            </div>
          ))}

          {/* Extra info card */}
          <div className="about-info-card">
            <div className="info-card-inner">
              <span className="info-icon">🎓</span>
              <h3>NIOS Board Exams</h3>
              <p>Specialized coaching for 10th &amp; 12th NIOS board examinations with personalised study plans and expert guidance.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
